import React from "react";
import {
  Paper,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import styled from "styled-components";

const Container = styled(Paper)`
  margin: 20px 0;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    margin: 10px 0;
    padding: 10px;
  }
`;

const QuestionContainer = styled.div`
  font-weight: 600;
`;

const OptionsContainer = styled.div`
  margin: 0 20px;
  @media only screen and (max-width: 600px) {
    margin: 0 10px;
  }
`;

const AnswerContainer = styled.div`
  margin: 0;
  font-weight: 600;
`;

const AnswerTitle = styled.span`
  font-weight: 600;
`;

const ExplanationContainer = styled.div`
  margin: 10px 0 0;
`;

export default ({ question, options, answer, explanation }) => {
  return (
    <Container>
      <QuestionContainer>問題) {question}</QuestionContainer>
      <OptionsContainer>
        {options.map((option, i) => (
          <p key={i}>{option}</p>
        ))}
      </OptionsContainer>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <AnswerTitle>解答</AnswerTitle>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            <AnswerContainer>{answer}</AnswerContainer>
            <ExplanationContainer>{explanation}</ExplanationContainer>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Container>
  );
};
